module.exports = __webpack_public_path__ + "static/media/poster_wide_l2.c6db0508.png";